import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
//import { loadState, saveState } from "./localStorage";
import thunkMiddleware from 'redux-thunk'

const composeEnhancers = (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = initialState => createStore(
  rootReducer,
  initialState,
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware
    )
  )
)

export default store;
